import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import { registerPinia } from "@/store";
import "./assets/style/main.scss";

import FloatingVue from "floating-vue";
import "floating-vue/dist/style.css";

import { VueDatePicker } from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";

const app = createApp(App);
registerPinia(app);
app.component("VueDatePicker", VueDatePicker);
app.use(FloatingVue).use(router).mount("#app");
